import { unstable_cache } from 'next/cache';

const SHORTS_QUOTA_BLOCK_REVALIDATE = 24 * 60 * 60;
export const YOUTUBE_QUOTA_SHORTS_TAG = 'youtube-quota-shorts';

class YouTubeQuotaBlockCacheMissError extends Error {
	constructor() {
		super('YouTube quota block cache miss');
		this.name = 'YouTubeQuotaBlockCacheMissError';
	}
}

let markQuotaBlockPending = false;
let shortsQuotaBlockedHint = false;

const getShortsQuotaBlockedFlag = unstable_cache(
	async () => {
		if (!markQuotaBlockPending) {
			throw new YouTubeQuotaBlockCacheMissError();
		}
		return true;
	},
	['youtube-shorts-quota-exceeded-flag'],
	{
		revalidate: SHORTS_QUOTA_BLOCK_REVALIDATE,
		tags: [YOUTUBE_QUOTA_SHORTS_TAG, 'youtube'],
	}
);

const cacheEmptyShortsAfterQuota = unstable_cache(
	async () => [],
	['youtube-shorts-quota-empty-fallback'],
	{
		revalidate: SHORTS_QUOTA_BLOCK_REVALIDATE,
		tags: [YOUTUBE_QUOTA_SHORTS_TAG, 'youtube', 'channel-shorts'],
	}
);

export async function markYouTubeShortsQuotaExceeded() {
	shortsQuotaBlockedHint = true;
	markQuotaBlockPending = true;
	try {
		await Promise.all([
			getShortsQuotaBlockedFlag(),
			cacheEmptyShortsAfterQuota(),
		]);
	} finally {
		markQuotaBlockPending = false;
	}
}

export async function isYouTubeShortsQuotaBlocked() {
	if (shortsQuotaBlockedHint) {
		return true;
	}
	try {
		const blocked = await getShortsQuotaBlockedFlag();
		if (blocked === true) {
			shortsQuotaBlockedHint = true;
		}
		return blocked === true;
	} catch (error) {
		if (error instanceof YouTubeQuotaBlockCacheMissError) {
			return false;
		}
		throw error;
	}
}

export function isYouTubeShortsDisabledByEnv() {
	return process.env.YOUTUBE_SHORTS_DISABLED === 'true';
}

export async function getCachedEmptyShortsAfterQuota() {
	return cacheEmptyShortsAfterQuota();
}
